import { api } from "@/api/api";

export const Product = {
    state: {
        productList: [],
    },
    getters: {
        getProductList(state) {
            return state.productList;
        },
    },
    mutations: {
        setProductList(state, payload) {
            state.productList = payload;
        },
    },
    actions: {
        async getProductList({ commit }) {
            await api.product
                .getProductList()
                .then((res) => {
                    commit("setProductList", res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async getCategoryProductList({ commit }, category) {
            await api.product
                .getCategoryProductList(category)
                .then((res) => {
                    console.log(res);
                    commit("setProductList", res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async searchProduct({ commit }, args) {
            await api.product
                .searchProduct(args)
                .then((res) => {
                    commit("setProductList", res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async addProduct({ dispatch }, args) {
            await api.product
                .addProduct(args)
                .then(() => {
                    dispatch("getProductList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async updateProduct({ dispatch }, args) {
            await api.product
                .updateProduct(args)
                .then(() => {
                    dispatch("getProductList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async deleteProduct({ dispatch }, args) {
            await api.product
                .deleteProduct(args)
                .then(() => {
                    dispatch("getProductList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async verifyProduct(_, args) {
            try {
                const res = await api.product.verifyProduct(args);
                return res.data;
            } catch (err) {
                console.log(err);
                return Promise.reject(err);
            }
        },

        async registerProductUser(_, args) {
            try {
                const res = await api.product.registerProductUser(args);
                return res.data;
            } catch (err) {
                console.log(err);
                return Promise.reject(err);
            }
        }
    },
};
